<div class="body">
  <mat-toolbar class="toolbar">
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title dashboard-toolbar-title">Radiation Safety Forms</span>
        </div>
        <div class="col-sm-12 col-md-3 d-flex align-items-start flex-column justify-content-center">
          <h1 class="blue" id="serialNumber" matTooltip="Open RSFs with active hold points">
            RSF Hold Points
          </h1>
          <span class="status blue">Live Status</span>
        </div>
        <div class="col-12 col-md-4 type-header d-flex align-items-center">
          <mat-form-field appearance="outline" class="no-subscript filter-field">
            <mat-label>Filter RSFs</mat-label>
            <input
              matInput
              type="text"
              [formControl]="filterControl"
              placeholder="Requester, affected system, serial number, or description"
            />
            <button
              *ngIf="filterControl.value"
              mat-icon-button
              matSuffix
              aria-label="Clear filter"
              (click)="filterControl.setValue('')"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end">
          <div class="d-flex small d-print-none">
            {{ filteredRows.length }} open RSF{{ filteredRows.length === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <div class="sidenav-content">
        <div class="dashboard-main">
      <div *ngIf="error" class="dashboard-message error-message">
            Hold-point status could not be loaded. Refresh the page and try again.
          </div>

          <div *ngIf="!loading && !error && !filteredRows.length" class="dashboard-message">
            No open RSFs match the current filter.
          </div>

          <div *ngIf="!loading && !error && filteredRows.length" class="matrix-wrapper">
            <table class="status-matrix">
              <thead>
                <tr>
                  <th class="rsf-column">RSF</th>
                  <th class="hold-points-column" matTooltip="Each circle represents a signature slot; checked circles are signed">
                    <div class="hold-points-header">
                      <span>Hold Points</span>
                      <div class="legend">
                        <span><i class="legend-box complete"></i>Fully signed</span>
                        <span><i class="legend-box partial"></i>Partially signed</span>
                        <span><i class="legend-box unsigned"></i>Not signed</span>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of filteredRows; trackBy: trackByRow">
                <tr
                  #rsfRow
                  [attr.data-rsf-serial]="row.serialNo"
                  [class.selected-rsf-row]="row.serialNo === selectedSerialNo"
                >
                  <th class="rsf-column row-heading">
                    <button
                      type="button"
                      class="serial-link"
                      [ngClass]="row.statusColor"
                      [matTooltip]="stripHtml(row.description)"
                      [matTooltipDisabled]="!stripHtml(row.description)"
                      matTooltipClass="tooltip-white tooltip-wide"
                      matTooltipPosition="right"
                      (click)="openRsf(row)"
                    >{{ row.serialNo }}</button>
                    <span class="rsf-meta">{{ row.requesterName || 'Requester unavailable' }}</span>
                    <span class="rsf-meta">{{ formatLocationNames(row.locationNames) || 'Affected systems unavailable' }}</span>
                    <div *ngIf="row.amendmentHoldPoints?.length" class="amendment-toggle-section">
                      <mat-slide-toggle
                        color="accent"
                        [checked]="isAmendmentHoldPointsVisible(row)"
                        (change)="toggleAmendmentHoldPoints(row, $event.checked)"
                      >Show pending amendment{{ row.activeAmendmentNumber ? ' ' + row.activeAmendmentNumber : '' }} hold points</mat-slide-toggle>
                    </div>
                  </th>
                  <td class="hold-points-column">
                    <div class="hold-point-list">
                      <div *ngFor="let cell of row.holdPoints" class="hold-point-item">
                        <div
                          class="hold-point-label"
                          [matTooltip]="stripHtml(cell.description || cell.name)"
                          matTooltipClass="tooltip-white tooltip-wide"
                          matTooltipPosition="above"
                        >Hold Point {{ cell.number }}</div>
                        <div class="status-box" [ngClass]="cell.state">
                          <div class="signature-list" *ngIf="getRequiredSignatures(cell).length">
                            <!-- Show each signature like checklist checkboxes with signer initials; read-only without the disabled grey styling. -->
                            <span
                              *ngFor="let signature of getRequiredSignatures(cell); trackBy: trackBySignature"
                              [matTooltip]="signatureTooltip(signature)"
                              matTooltipClass="tooltip-white tooltip-wide"
                              matTooltipPosition="below"
                            >
                              <mat-checkbox-with-roles
                                class="read-only-signature"
                                [labelPosition]="'before'"
                                [checked]="signature.signed"
                                [user]="getSignatureUser(signature)"
                                [date]="getSignedOn(signature)"
                              ></mat-checkbox-with-roles>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="row.amendmentHoldPoints?.length && isAmendmentHoldPointsVisible(row)"
                      class="amendment-hold-point-section"
                    >
                      <div class="hold-point-list amendment-hold-point-list">
                        <div *ngFor="let cell of row.amendmentHoldPoints" class="hold-point-item">
                          <div
                            class="hold-point-label"
                            [matTooltip]="stripHtml(cell.description || cell.name)"
                            matTooltipClass="tooltip-white tooltip-wide"
                            matTooltipPosition="above"
                          >Hold Point {{ cell.number }}</div>
                          <div class="status-box" [ngClass]="cell.state">
                            <div class="signature-list" *ngIf="getRequiredSignatures(cell).length">
                              <!-- Show each signature like checklist checkboxes with signer initials; read-only without the disabled grey styling. -->
                              <span
                                *ngFor="let signature of getRequiredSignatures(cell); trackBy: trackBySignature"
                                [matTooltip]="signatureTooltip(signature)"
                                matTooltipClass="tooltip-white tooltip-wide"
                                matTooltipPosition="below"
                              >
                                <mat-checkbox-with-roles
                                  class="read-only-signature"
                                  [labelPosition]="'before'"
                                  [checked]="signature.signed"
                                  [user]="getSignatureUser(signature)"
                                  [date]="getSignedOn(signature)"
                                ></mat-checkbox-with-roles>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
  </div>
</div>
